<template>
  <div>
    <Header
            :productRequestAlert = "productRequestAlert"
    ></Header>
    <main class="d-flex flex-column flex-lg-row">
      <categories-side-menu></categories-side-menu>
      <current-product
              @openLogModal ="openLogModal"
      ></current-product>
    </main>
  </div>
</template>

<script>
import Header from '../components/global/Header.vue'
import categoriesSideMenu from '../components/categories/categoriesSideMenu'
import currentProduct from '../components/products/currentProduct'

export default {
  name: 'ProductPage',
  components: {
    Header,
    categoriesSideMenu,
    currentProduct
  },
  data: () => ({
    productRequestAlert: false
  }),
  methods: {
    openLogModal () {
      this.productRequestAlert = !this.productRequestAlert
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/Product.vue